// src/components/achievements/AchievementList.js
import React, { useEffect, useState } from 'react';
import NavLink from './../common/NavLink';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const AchievementList = () => {
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/achievements-list`)
      .then(res => res.json())
      .then(data => {
        setAchievements(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Błąd ładowania listy rankingów', err);
        setLoading(false);
      });
  }, []);

  if (loading) return <Typography textAlign="center" py={8}>Ładowanie rankingów...</Typography>;

  const getColor = (color) => {
    if (color === 'green') return '#4caf50';
    if (color === 'red') return '#f44336';
    return '#bbbbbb';
  };

  return (
    <Box sx={{ maxWidth: 1000, mx: 'auto'}}>
      <Typography variant="h4" align="center" gutterBottom sx={{ color: '#fff', fontWeight: 700, mb: 5 }}>
        Wybryki statystyczne
      </Typography>

      <TableContainer component={Paper} sx={{ bgcolor: '#1a1a1a', borderRadius: 2 }}>
        <Table size="medium">
          <TableHead>
            <TableRow sx={{ bgcolor: '#111' }}>
              <TableCell sx={{ color: '#aaa', fontSize: { xs: '0.9rem', md: '1.1rem' }, width: '70%' }}>
				<Typography align="center">
					Kategoria
				</Typography>
              </TableCell>
              <TableCell sx={{ color: '#aaa', fontSize: { xs: '0.9rem', md: '1.1rem' }, width: '30%' }}>
                <Typography align="center">
					Lider
				</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {achievements.map((ach) => {
              const top1 = ach.top1 || {};
              const leagueDisplay = top1.group && top1.group.trim() !== ''
                ? `${top1.league} (${top1.group})`
                : top1.league || '-';

              return (
                <TableRow
                  key={ach.key}
                  component={NavLink}
                  to={ach.url}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': { bgcolor: 'rgba(255,255,255,0.05)' },
                    transition: 'background 0.2s',
                  }}
                >
                  {/* Kolumna Kategoria */}
                  <TableCell align="center">
                    <Typography
                      sx={{
                        fontSize: { xs: '0.9rem', md: '1.0rem' },
                        fontWeight: 600,
                        color: getColor(ach.color),
                      }}
                    >
                      {ach.title}
                    </Typography>
                  </TableCell>

                  {/* Kolumna Lider */}
                  <TableCell align="center">
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      {/* Nazwa drużyny */}
                      <Typography
					  component={NavLink}
                      to={`/team/${top1.teamId}`}
                        sx={{
                          fontSize: { xs: '0.85rem', md: '0.95rem' },
                          fontWeight: 550,
                          color: '#fff',
                          lineHeight: 1.2,
                        }}
                      >
                        {top1.teamName || 'Brak danych'}
                      </Typography>

                      {/* Nazwa ligi */}
                      {top1.league && (
                        <Typography
						component={NavLink}
						to={`/liga/${top1.competitionId}`}
                          sx={{
                            fontSize: { xs: '0.75rem', md: '0.85rem' },
                            color: '#bbbbbb',
                            lineHeight: 1.2,
                          }}
                        >
                          {top1.league}
                        </Typography>
                      )}

                      {/* Grupa ligi */}
                      {top1.group && top1.group.trim() !== '' && (
                        <Typography
						component={NavLink}
						to={`/liga/${top1.competitionId}`}
                          sx={{
                            fontSize: { xs: '0.65rem', md: '0.75rem' },
                            color: '#888888',
                            lineHeight: 1.2,
                          }}
                        >
                          ({top1.group})
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AchievementList;